




























import {
  defineComponent,
  ref,
  watch
} from '@nuxtjs/composition-api';
import { SfButton } from '@storefront-ui/vue';

export default defineComponent({
  name: 'CategorySearch',
  props: {
    search: {
      type: String,
      default: ''
    }
  },
  components: {
    SfButton
  },
  emits: ['submit'],
  setup (props, { emit }) {
    const term = ref<string>(props.search);
    const onSubmit = () => {
      emit('submit', term.value)
    }

    const clearSearch = () => {
      term.value = '';
      emit('submit', term.value);
    }

    watch(() => props.search, () => {
      term.value = props.search
    }, { immediate: true })

    return {
      term,
      onSubmit,
      clearSearch
    }
  }
})
